var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper"},[_c('art-detail',{attrs:{"detail-type":"home","back-func":_vm.handleBack}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }